export const getLocalUrl = (path: string) => {
  return `${window.location.origin}${path}`;
};
